export default __webpack_public_path__ + "static/media/contefinanciera.65b78b56.png";